export default __webpack_public_path__ + "src/images/bg_preface-eefbaa.png";